import MuiRating from "@mui/material/Rating";

const Rating = MuiRating;

export default Rating;
